export const CONTENT_MAX_LENGTH = 2000;

export const stripHtmlPlainText = (html) => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\u00a0/g, ' ').trim();
};

export const getPlainTextLength = (html) => stripHtmlPlainText(html).length;

export default stripHtmlPlainText;
